import { createCustomEnum } from "./customEnum";

export type MerchantStatusKeys = "active" | "closed" | "terminated" | "other";

export const MerchantStatus = createCustomEnum({
	Active: {
		name: "active",
		value: 0,
		displayName: "Active Merchant",
	},
	Closed: {
		name: "closed",
		value: 1,
		displayName: "Closed Merchant",
	},
	Terminated: {
		name: "terminated",
		value: 2,
		displayName: "Terminated",
	},
	Other: {
		name: "other",
		value: 3,
		displayName: "Other",
	},
});
